import { defineMessages } from 'react-intl';

export const scope = 'app.components.MyAssignmentsPage';

export const messages = defineMessages({
  scored: {
    id: `${scope}.scored`,
    defaultMessage: 'Scored',
  },
  // List
  listLoadError: {
    id: `${scope}.listLoadError`,
    defaultMessage: "Couldn't load your assignments. Please try again.",
  },
  listEmpty: {
    id: `${scope}.listEmpty`,
    defaultMessage: 'You have no calibration assignments.',
  },
  listRefreshError: {
    id: `${scope}.listRefreshError`,
    defaultMessage: "Couldn't refresh — showing your last loaded assignments.",
  },
  videosToScore: {
    id: `${scope}.videosToScore`,
    defaultMessage: '{count} {video} to score',
  },
  assignedDue: {
    id: `${scope}.assignedDue`,
    defaultMessage: 'Assigned {assigned} · Due {due}',
  },
  scoredCount: {
    id: `${scope}.scoredCount`,
    defaultMessage: '{scored}/{total} scored',
  },
  statusCompleted: {
    id: `${scope}.statusCompleted`,
    defaultMessage: 'Completed',
  },
  statusPending: {
    id: `${scope}.statusPending`,
    defaultMessage: 'Pending',
  },
  loadMoreError: {
    id: `${scope}.loadMoreError`,
    defaultMessage: "Couldn't load more assignments. Please try again.",
  },
  loadingMore: {
    id: `${scope}.loadingMore`,
    defaultMessage: 'Loading…',
  },
  loadMore: {
    id: `${scope}.loadMore`,
    defaultMessage: 'Load more',
  },
  // Scoring
  scoringLoadError: {
    id: `${scope}.scoringLoadError`,
    defaultMessage: "Couldn't load this assignment. Please try again.",
  },
  noticeUnavailable: {
    id: `${scope}.noticeUnavailable`,
    defaultMessage: 'This assignment is no longer available.',
  },
  noticeNoVideos: {
    id: `${scope}.noticeNoVideos`,
    defaultMessage: 'This assignment has no videos to score.',
  },
  completeThanks: {
    id: `${scope}.completeThanks`,
    defaultMessage: 'This assignment is complete. Thanks for scoring all {total} videos.',
  },
  backToAssignments: {
    id: `${scope}.backToAssignments`,
    defaultMessage: 'Back to Assignments',
  },
  saveErrorRetry: {
    id: `${scope}.saveErrorRetry`,
    defaultMessage: "Couldn't save your scores yet. They're saved on this device and will retry.",
  },
  saving: {
    id: `${scope}.saving`,
    defaultMessage: 'Saving…',
  },
  thanksAll: {
    id: `${scope}.thanksAll`,
    defaultMessage: 'Thanks for scoring all {total} videos.',
  },
  reachedEnd: {
    id: `${scope}.reachedEnd`,
    defaultMessage: "You've reached the end — {scored} of {total} scored.",
  },
  goBackLastScore: {
    id: `${scope}.goBackLastScore`,
    defaultMessage: '‹ Go back to last score',
  },
  backToList: {
    id: `${scope}.backToList`,
    defaultMessage: '‹ Assignments',
  },
  due: {
    id: `${scope}.due`,
    defaultMessage: 'Due {due}',
  },
  videoOfTotal: {
    id: `${scope}.videoOfTotal`,
    defaultMessage: 'Video {current} of {total}',
  },
  finish: {
    id: `${scope}.finish`,
    defaultMessage: 'Finish ›',
  },
  next: {
    id: `${scope}.next`,
    defaultMessage: 'Next ›',
  },
  prev: {
    id: `${scope}.prev`,
    defaultMessage: '‹ Prev',
  },
});
